import { Link } from "react-router-dom"
import { MapPin, User, Flag, ExternalLink, Edit, Trash } from "lucide-react"

const QueryHeader = ({ queryData, handleImageClick, onReport, onEdit, onDelete, isOwner }) => {
  const renderPosterProfile = () => {
    const profileContent = (
      <>
        {queryData.posterPhoto ? (
          <img src={queryData.posterPhoto || "/placeholder.svg"} alt="Poster" className="poster-photo" />
        ) : (
          <div className="poster-avatar">
            <User size={18} />
          </div>
        )}
        <span className="poster-name">{queryData.posterName || "Anonymous"}</span>
        {queryData.posterBadge && <span className="poster-badge">{queryData.posterBadge}</span>}
      </>
    );
    
    // Only link if we have a valid user ID (createdBy)
    if (queryData.createdBy && queryData.createdBy !== 'anonymous') {
      return (
        <Link to={`/users/${queryData.createdBy}`} className="profile-link poster-profile-link">
          {profileContent}
        </Link>
      );
    }
    
    return profileContent;
  };

  return (
    <header className="query-header">
      <div className="poster-info">
        {renderPosterProfile()}
        <div className="query-actions">
          {isOwner ? (
            <>
              <button 
                className="action-btn edit-btn"
                onClick={onEdit}
                title="Edit query"
              >
                <Edit size={16} />
                <span>Edit</span>
              </button>
              <button 
                className="action-btn delete-btn"
                onClick={onDelete}
                title="Delete query"
              >
                <Trash size={16} />
                <span>Delete</span>
              </button>
            </>
          ) : (
            <button 
              className="action-btn report-btn"
              onClick={onReport}
              title="Report this query"
            >
              <Flag size={16} />
              <span>Report</span>
            </button>
          )}
        </div>
      </div>

      <h1 className="query-title">{queryData.title}</h1>
      
      <div className="query-description">
        {typeof queryData.description === 'string' 
          ? queryData.description 
          : JSON.stringify(queryData.description)}
      </div>

      {queryData.tags && queryData.tags.length > 0 && (
        <div className="query-tags">
          {queryData.tags.map((tag, index) => (
            <span key={index} className="query-tag">
              {tag}
            </span>
          ))}
        </div>
      )}

      {queryData.location && (
        <div className="query-location">
          <MapPin size={16} />
          <span>{queryData.location}</span>
        </div>
      )}
      
      {queryData.imageUrls?.length > 0 || queryData.attachments?.length > 0 ? (
        <div className="attachments-container">
          <h3 className="attachments-heading">Attachments</h3>
          <div className="attachments-grid">
            {[...(queryData.imageUrls || []), ...(queryData.attachments || [])].map((url, index) => (
              <div key={index} className="attachment-item" onClick={() => handleImageClick(url)}>
                <img 
                  src={url || "/placeholder.svg"} 
                  alt={`Attachment ${index + 1}`} 
                  className="query-image"
                  onError={(e) => {
                    e.target.onerror = null; 
                    e.target.src = "/placeholder.svg";
                  }} 
                />
              </div>
            ))}
          </div>
        </div>
      ) : null}
      
      {queryData.crowdfundingLink && (
        <div className="support-section">
          <a 
            href={queryData.crowdfundingLink}
            target="_blank"
            rel="noopener noreferrer"
            className="support-button"
          >
            <ExternalLink size={16} />
            <span>Support this cause</span>
          </a>
          
          {queryData.crowdfundingSummary ? (
            <div className="crowdfunding-summary">
              <h3>Crowdfunding Summary</h3>
              <div className="crowdfunding-details">
                <p>
                  <strong>Campaign Title:</strong> {queryData.crowdfundingSummary.title || "Campaign Title Unavailable"}
                </p>
                <p>
                  <strong>Description:</strong> {queryData.crowdfundingSummary.description || "No description available"}
                </p>
                <p>
                  <strong>Raised:</strong> {queryData.crowdfundingSummary.raisedFormatted || 
                    (typeof queryData.crowdfundingSummary.raised === 'number' ? 
                    `$${queryData.crowdfundingSummary.raised.toLocaleString()}` : 
                    "Amount unavailable")}
                </p>
                <p>
                  <strong>Goal:</strong> {queryData.crowdfundingSummary.goalFormatted || 
                    (typeof queryData.crowdfundingSummary.goal === 'number' ? 
                    `$${queryData.crowdfundingSummary.goal.toLocaleString()}` : 
                    "Goal unavailable")}
                </p>
              </div>
            </div>
          ) : (
            <div className="crowdfunding-summary crowdfunding-loading">
              <p>Loading crowdfunding details...</p>
            </div>
          )}
        </div>
      )}
    </header>
  );
};

export default QueryHeader;

